import React, { Component } from 'react';
import CustomModal from './index';
import {
  ColorButton,
  ValueText,
  SwitchContainer,
  DropFile,
  AddCostTypeModal
} from '../../../../index';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Help from '../../../../../assets/images/module/general/Help.svg';
import calendar from '../../../../../assets/images/module/general/CalendarIcon.svg';
import { connect } from 'react-redux';
import RangeDatePicker from './DateRangePicker';
import Autoload from '../../../../Autoload';
import moment from 'moment';
import GlobalServices from '../../../../helpers/services/GlobalServices';
import GeneralDataHandler from '../../../../helpers/DataHandler/General';

import { showNotification, hideNotification } from '@mantine/notifications';
import RedTick from '../../../../../assets/images/module/general/RedTick.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import AddIcon from '../../../../../assets/images/module/general/AddIcon.svg';
import Logo from '../../../../../assets/images/module/general/Logo.svg';
import Messenger from '../../../../../assets/images/module/general/Messenger.svg';

import {
    setPublishMessageId,
    setRefreshMessagesData
  } from '../../../../../redux/action/General/generalActions';

// Get receipts endpoint from new config
import { config } from '../../../../config/Setting';
import { Check, ThreeDRotationSharp } from "@material-ui/icons";
import { Alert, Group, Stack, Text } from "@mantine/core";
import * as customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs';
import CopyIcon from '../../../SVGs/copyIcon';
import { formatNumber } from '../../../../../helpers/stringsManipulations';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
var { checkProperty, yearDifference, yearDifferenceMoment } = Autoload.MainHelper;
dayjs.extend(customParseFormat)

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

class MessageConfirmationModal extends Component {
  state = {
    
  };
  
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    
  }
  
  render() {
    const { open, toggle, className, postalFee, onSend, allRecipients } = this.props;
    const { data } = this.state;
    console.log('postalFee: ', postalFee);
    return (
      <>
        <CustomModal
          heading={'Versand bestätigen'}
          headingClassName='select-template-heading'
          open={open}
          toggle={() => {
            toggle();
          }}
          className={`${className}`}
        >
            <Stack>
                <Group><span style={{fontWeight: '400'}}>Die Nachricht wird an {allRecipients.length} Empfänger entsprechend der gewählten Versandmethoden gesendet. {(postalFee.totalPostalFee && postalFee.totalPostalFee > 0)  ? `Es entstehen voraussichtliche Portokosten i.H.v. ${formatNumber(postalFee.totalPostalFee, true)}.` : ''} Sind Sie sicher, dass Sie die Nachricht versenden wollen?</span></Group>
                <Group justify="space-between">
                    <div>
                        <ColorButton
                        text={'Abbrechen'}
                        className={'gray-btn'}
                        onClick={()=> toggle()}
                        />
                    </div>
                    <div>
                        <ColorButton
                        text={'Versenden'}
                        className={'purple-btn'}
                        onClick={()=> onSend()}
                        />
                    </div>
                </Group>
            </Stack>
        </CustomModal>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property
  };
};

const actions = {
    setPublishMessageId,
    setRefreshMessagesData
  };

export default connect(mapStateToProps, actions)(MessageConfirmationModal);
